// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ai","content":"Bi","crumbsList":"Ci","dropdownsWrap":"Di"};